export default __webpack_public_path__ + "static/media/bus-icon.20dcbc18.svg";